import React, { useEffect, useState } from 'react';
import { getAuthToken } from '../../../../../../../../auth/tokenvalidation';
import {
  isLpgProductId,
  usesDyedUndyedAlpha,
  getAlphaColumnLabel,
  requiresLpgCargoRatio,
} from '../../../../../../../../shared/offer-domain/constants';
import { fetchProductTypePricingUnit } from '../../../../../../utils/deliveryDetailUtils';
import DeliveryDetailTableNonLpg from './nonLpg/DeliveryDetailTableNonLpg';
import DeliveryDetailTableLpg from './lpg/DeliveryDetailTableLpg';

const DeliveryDetailTable = ({
  items = [],
  productNameId = null,
  productTypeId = null,
  form = null,
}) => {
  const [pricingUnit, setPricingUnit] = useState(null);
  const usesDyedUndyed = usesDyedUndyedAlpha(productNameId);

  useEffect(() => {
    if (isLpgProductId(productNameId) || usesDyedUndyed) {
      setPricingUnit(null);
      return;
    }
    const token = getAuthToken();
    let cancelled = false;
    fetchProductTypePricingUnit(productTypeId, token).then(unit => {
      if (!cancelled) setPricingUnit(unit);
    });
    return () => {
      cancelled = true;
    };
  }, [productNameId, productTypeId, usesDyedUndyed]);

  if (isLpgProductId(productNameId)) {
    return (
      <DeliveryDetailTableLpg
        items={items}
        requiresCargoRatio={requiresLpgCargoRatio(
          form ?? { productNameId, productTypeId }
        )}
      />
    );
  }

  return (
    <DeliveryDetailTableNonLpg
      items={items}
      usesDyedUndyed={usesDyedUndyed}
      alphaColumnLabel={getAlphaColumnLabel(pricingUnit)}
      pricingUnit={pricingUnit}
    />
  );
};

export default DeliveryDetailTable;
